<script>
import DataProvider from './DataProvider.vue';
import DepartmentRepository from '../../js/repository/DepartmentRepository';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        departmentId: {
            type: Number,
            required: true,
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: DepartmentRepository.findTeams,
                params: [this.departmentId],
            },
            scopedSlots: this.$scopedSlots,
        });
    }
}
</script>
